import { Component, OnInit, Input } from '@angular/core';
import { MitterService } from '../../../services/mitter.service';
import { getTimelineEvent, makeMessage } from '../../utils/message-utils';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import * as moment from 'moment';

@Component({
  selector: 'mitter-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  @Input() message: any;
  @Input() galleryOptions: NgxGalleryOptions[];
  @Input() galleryImages: NgxGalleryImage[];

  mitter: any;
  timestamp: string;
  isUserSentMessage: boolean;
  messageContainerClasses: object;
  isFailed: boolean;

  constructor(private mitterService: MitterService) {
    this.mitter = mitterService.getMitter();
  }

  ngOnInit() {
    let senderId: string = this.message.senderId.identifier;
    let userId: string = this.mitter.getUserId();
    this.isUserSentMessage = userId === senderId;

    let timelineEvent = this.isUserSentMessage ?
      this.message.timelineEvents.find(event => event.type === 'mitter.mtet.SentTime') :
      this.message.timelineEvents.find(event => event.type === 'mitter.mtet.DeliveredTime');
    this.timestamp = moment(timelineEvent && timelineEvent.eventTimeMs).format('LT');

    let isPrescription = this.message.messageData &&
      this.message.messageData.length > 0 &&
      this.message.messageData.find(d => d.dataType === 'petcart.messageInfo') &&
      this.message.messageData.find(d => d.dataType === 'petcart.messageInfo').data.isPrescription;

    this.messageContainerClasses = {
      'mt-message-container': true,
      'mt-message-outgoing': this.isUserSentMessage,
      'mt-message-incoming': !this.isUserSentMessage,
      'mt-message-prescription': isPrescription
    };

    this.isFailed = this.message.state && this.message.state === 'FAILED';
    this.shouldSendReadReceipt() && this.sendReadReceipt();
  }

  shouldSendReadReceipt() {
    return !this.isUserSentMessage &&
      !this.message.timelineEvents.find(e =>
        e.type === 'mitter.mtet.ReadTime' && e.subject.identifier === this.mitter.getUserId());
  }

  sendReadReceipt() {
    const readTimeEvent = getTimelineEvent('mitter.mtet.ReadTime', this.mitter.getUserId());
    this.mitter.sendTimelineEventAsync(this.message.channelId, this.message.messageId, readTimeEvent);
  }

  resendMessage() {
    const newMessage = Object.assign({}, this.message);
    if ('state' in newMessage) delete(newMessage.state);
    if ('channelId' in newMessage) delete(newMessage.channelId);
    this.mitter.sendMessageAsync(this.message.channelId, newMessage);
  }
}
